window.__APP_VERSION = require('./app.version.js');
